// extracted by mini-css-extract-plugin
export default {"container":"NonClinic_container__ZzkPb","heading":"NonClinic_heading__rX+Sk","screeningHeader":"NonClinic_screeningHeader__Mqru4"};